import api from 'api'

export const fetchProject = async (id, all) => {
  const { data } = await api.get(
    all ? `/project/${id}/full` : `/project/${id}`
  )

  return data
}
